import { Button } from 'components/Button';
import { ContainedModal } from 'components/molecules';
import { useTreatmentConsultation } from 'context';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ICreateTreatmentConsultation } from 'types';

import { Stack } from '@mui/material';

import { TreatmentPrescriptionList } from '../TreatmentPrescriptionList';

export const SaveTreatmentPrescriptionModal: React.FC = () => {
  const {
    saveTreatmentPrescriptionModal,
    savePrescription,
    loading,
    currentTreatmentConsultation,
  } = useTreatmentConsultation();

  const form = useForm<Pick<ICreateTreatmentConsultation, 'prescription'>>({
    defaultValues: {
      prescription: currentTreatmentConsultation?.prescription ?? [],
      ...currentTreatmentConsultation,
    },
  });

  useEffect(() => {
    form.reset({
      prescription: currentTreatmentConsultation?.prescription ?? [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTreatmentConsultation]);

  return (
    <ContainedModal
      isOpen={saveTreatmentPrescriptionModal.isOpen}
      onClose={saveTreatmentPrescriptionModal.onClose}
      title={
        currentTreatmentConsultation?.prescription?.length
          ? 'EDITAR PRESCRIÇÃO'
          : 'NOVA PRESCRIÇÃO'
      }
    >
      <FormProvider {...form}>
        <Stack px={3} mt={4} spacing={2}>
          <TreatmentPrescriptionList />

          <Stack spacing={2} direction="row" justifyContent="flex-end">
            <Button
              disabled={loading}
              variant="outlined"
              onClick={saveTreatmentPrescriptionModal.onClose}
            >
              CANCELAR
            </Button>

            <Button
              onClick={form.handleSubmit(savePrescription)}
              loading={loading}
              disabled={loading}
            >
              GERAR PRESCRIÇÃO
            </Button>
          </Stack>
        </Stack>
      </FormProvider>
    </ContainedModal>
  );
};
